import React, {useRef} from 'react';

import {WithModalContext} from '../../../modalContext';
import {Dialog} from '../modal-features/Dialog';
import {ModalBody} from '../modal-sections/ModalBody';
import {ModalContainer} from '../modal-sections/ModalContainer';
import {ModalFooter} from '../modal-sections/ModalFooter';
import {ModalHeader} from '../modal-sections/ModalHeader';
import {ModalLabel, ModalTitle} from '../modal-sections/ModalTitle';

/**
 * @param {object} param0
 * @param {React.ReactNode} param0.children
 * @param {boolean} [param0.overflowNone]
 * @param {boolean} [param0.overflowUnset]
 * @param {boolean} param0.show
 * @param {'sm' | 'md' | 'lg' | 'xl' | 'xl-fixed-height'} [param0.size]
 * @param {React.ReactNode} param0.title
 * @param {() => void} [param0.onHide]
 */
const ModalDialog = ({overflowNone, ...props}) => {
    const modalRef = useRef(null);
    return (
        <WithModalContext isInModal={true} modalRef={modalRef}>
            <Dialog overflowNone={overflowNone} backdrop={true} {...props} dialogRef={modalRef} />
        </WithModalContext>
    );
};

ModalDialog.Wrapper = ModalContainer;
ModalDialog.Title = ModalTitle;
ModalDialog.Header = ModalHeader;
ModalDialog.Body = ModalBody;
ModalDialog.Footer = ModalFooter;
ModalDialog.Label = ModalLabel;

export {ModalBody, ModalContainer, ModalDialog, ModalFooter, ModalHeader, ModalLabel, ModalTitle};
